import { ReactNode } from "react";
import { IconName } from "react-frontier";

export interface APIResponse<T=any>{
	error: boolean,
	code: string,
	message: string,
	data?: T & { [x: string]: any },
}

export type SetLoading = (l: boolean)=>void;

export interface LoginAuth{
	user_id: number,
	first_name: string,
	last_name: string,
	email: string,
	admin?: boolean,
	token: string,
	expiration: number,
}

export enum CardBrand{
	VISA = 1,
	MASTERCARD = 2,
	AMERICAN_EXPRESS = 3,
	OTHER = 99,
}

export enum PaymentCardType{
	CREDIT = 1,
	DEBIT = 2,
	UNKNOWN = 99,
}

export enum FilterType{
	VALUE = 1,
	LIKE = 2,
	REGEXP = 3,
}

export interface SearchFilter{
	key: string,
	value: string,
	type?: FilterType,
}

export interface Payout{
	payout_id: number,
	client_id: number,
	client_name: string,
	amount_paid: number,
	paid: boolean,
	cancelled: boolean,
	date_created: number,
	date_paid: number,
	date_cancelled: number,
}

export interface Breadcrumb{
	url: string,
	iconName?: IconName,
	text: string,
}

export interface SiteRoute{
	path: string,
	element: ReactNode,
	title: string | ((params: any)=>string),
	iconName?: IconName,
	children?: SiteRoute[]
}


export {}